import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import ICONS from '../../constants/icons';

import debounce from '../../helpers/debounce';

// Hooks
import useFilterParam from '../../hooks/aampeTable/useFilterParam';
import useQueryParams from '../../hooks/helper/useQueryParams';

// components
import SearchInput from '../inputs/SearchInput';

interface AampeTableSearchProps {
    tableName?: string;
    className?: string;
    wrapperStyle?: React.CSSProperties;
    removeBorderBottom?: boolean;
    placeholder?: string;
}

const AampeTableSearchNew: React.FC<
    React.PropsWithChildren<AampeTableSearchProps>
> = ({ tableName, className, wrapperStyle, placeholder }) => {
    const location = useLocation();
    const params = useQueryParams();

    const [searchVal, setSearchVal] = useFilterParam(
        tableName ?? '',
        'search',
        '',
    );

    const [value, setValue] = useState<string>(searchVal);

    const debounceOnChange = debounce((val: string) => {
        setSearchVal(val);
    }, 500);

    useEffect(() => {
        if (!Object.keys(params)?.length) {
            setSearchVal('');
            setValue('');
        }
    }, [location.pathname, params, setSearchVal, setValue]);

    const onChange = (val: string) => {
        setValue(val);
        debounceOnChange(val);
    };

    return (
        <SearchInput
            value={value as string}
            placeholder={placeholder || 'Search this list'}
            setValue={onChange}
            leadingIcon={<ICONS.searchV2 width={20} height={20} />}
            wrapperStyle={{
                marginLeft: 'auto',
                ...wrapperStyle,
            }}
            className={className}
        />
    );
};

export default React.memo(AampeTableSearchNew);
